import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { arrowRightIcon, locationIcon, userIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React, { useEffect, useState } from 'react'
import { SwiperSlide, Swiper } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import style from './styles/stories.module.scss'
// import Button from '@/components/Button'
import SliderContainer from '@/components/Container/SliderContainer'
import { api } from '@/api'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import HtmlContent from '@/components/HtmlContent'
// import { useConfig } from '@/hooks'

SwiperCore.use([Navigation])

const SuccessStories = (): React.ReactElement => {
  const [data, setData] = useState<any[]>([])
  // const config = useConfig()

  useEffect(() => {
    api
      .getSuccessStoryList()
      .then(data => {
        setData(data.results)
      })
      .catch(error => console.error(error))
  }, [])

  return (
    <Section>
      <Container>
        <Title type='h2' theme='h1' className={style.stories__title}>
          Истории успеха
        </Title>
      </Container>

      <SliderContainer>
        <div className={style.slider_buttons}>
          <button className='slider_button slider_button_prev js_stories_prev'>
            <GxIcon src={arrowRightIcon} className={style.slider__icon} />
          </button>
          <button className='slider_button slider_button_next js_stories_next'>
            <GxIcon src={arrowRightIcon} className={style.slider__icon} />
          </button>
        </div>
        <Swiper
          slidesPerView='auto'
          spaceBetween={20}
          resizeObserver
          navigation={{
            prevEl: '.js_stories_prev',
            nextEl: '.js_stories_next'
          }}
          freeMode
          grabCursor
        >
          {data.length === 0
            ? (
              <SwiperSlide className={style.slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
              )
            : (
                data.map(slide => {
                  return (
                    <SwiperSlide key={slide.id} className={style.slide}>
                      <div className={style.slide_left}>
                        <div className={style.slide_location}>
                          <GxIcon
                            src={locationIcon}
                            className={style.slide_location__icon}
                          />
                          {slide.property_place_value}
                        </div>
                        <Title type='h3' theme='h3' className={style.slide__name}>
                          {slide.name}
                        </Title>
                        <HtmlContent
                          className={style.slide__text}
                          content={slide.preview_text}
                        />
                      </div>
                      {slide.preview_picture !== null
                        ? (
                          <img
                            src={slide.preview_picture?.[0]}
                            height='309px'
                            width='309px'
                            alt={slide.name}
                            className={style.slide__photo}
                          />
                          )
                        : (
                          <div className={style.slide_ava}>
                            <GxIcon
                              src={userIcon}
                              className={style.slide_ava__icon}
                            />
                          </div>
                          )}

                      {/* <Button
                        size='large'
                        corner
                        wide
                        highlight
                        href={`${config.success_story}?element_id=${String(
                      slide.id
                    )}`}
                        className={style.slide__button}
                      >
                        Читать
                      </Button> */}
                    </SwiperSlide>
                  )
                })
              )}
        </Swiper>
      </SliderContainer>
    </Section>
  )
}

export default SuccessStories
